import React from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';

import InputLabel from '@material-ui/core/InputLabel';

import Typography from '@material-ui/core/Typography';
import {SERVER_URL} from '../../shared/utils/Constants';
import GeneralUtils from "../../shared/utils/GeneralUtils";
import {toast} from 'react-toastify';

import ReCAPTCHA from 'react-google-recaptcha';

import OutlinedInput from "@material-ui/core/OutlinedInput";
import PasswordResetInitMerchant from "./PasswordResetInitMerchant";
import PasswordResetFinishMerchant from "./PasswordResetFinishMerchant";
import LicenseService from "../../shared/service/LicenseService";
import MerchantBranchService from "../../shared/service/MerchantBranchService";
import SystemParamsService from "../../shared/service/SystemParamsService";
import Package from "../../../package.json";
import AdminUserService from "../../shared/service/AdminUserService";
import MerchantUserService from "../../shared/service/MerchantUserService";
import CurrentUserService from "../../shared/service/CurrentUserService";
import './LoginPage.css';

global.appVersion = Package.version;

class LoginMerchant extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            reCaptchaToken: null,
            userName: null,
            domainName: null,
            password: null,
            panel: 'login',
            loginShow: true,
            showCaptcha: true

        };
        this.merchantBranchService = new MerchantBranchService();
        this.licenseService = new LicenseService();
        this.systemParamsService = new SystemParamsService();
        this.merchantUserService = new MerchantUserService();
        this.adminUserService = new AdminUserService();
        this.currentUserService = new CurrentUserService();

    }

    componentDidMount() {

        this.systemParamsService.getSystemParams().then(response => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({
                        showCaptcha: response.showCaptcha,
                    });
                }

            }
        );

        if (this.reCAPTCHA) {
            this.reCAPTCHA.reset();
        }

        //document.addEventListener('keydown', this.onKeyDown);

        if (GeneralUtils.getParameterByName('passwordChangeKey') !== null) {
            this.setState({
                panel: 'passwordResetFinish',
                passwordChangeKey: GeneralUtils.getParameterByName('passwordChangeKey')
            });
        }
        if (GeneralUtils.getParameterByName('activationKey') !== null) {
            this.setState({
                panel: 'passwordResetFinish',
                activationKey: GeneralUtils.getParameterByName('activationKey')
            });
        }


        if (!GeneralUtils.isNullOrEmpty(localStorage.getItem("clientId"))) {
            this.setState({
                domainName: localStorage.getItem("clientId")
            });
        }


    }

    onChange = (reCaptchaToken) => {
        this.setState({reCaptchaToken: reCaptchaToken});
    }

    isLoginSubmitDisabled = () => {
        return this.state.showCaptcha && !this.state.reCaptchaToken;
    }

    renderBrand() {
        return (
            <div className="login-page__brand">
                <img
                    className="login-page__logo"
                    alt="Dispatchio"
                    src="assets/layout/images/dispatchio.png"/>
                <p className="login-page__version">V{global.appVersion}</p>
            </div>
        );
    }

    render() {
        if (this.state.panel === 'login') {
            return this.getLoginPanel();
        } else {
            return this.getPasswordResetPanel();
        }

    }

    getPasswordResetPanel = () => {
        const title = !GeneralUtils.isNullOrEmpty(this.state.activationKey)
            ? 'User Activation'
            : 'Reset Password';

        return (
            <div className="login-page login-background">
                <main className="login-page__main">
                    <CssBaseline/>
                    <div className="login-page__card">
                        {this.renderBrand()}
                        <Typography component="h1" variant="h6" className="login-page__title">
                            {title}
                        </Typography>
                        <div className="login-page__reset-body">
                            {this.getPasswordResetContent()}
                        </div>
                        <Button
                            fullWidth
                            variant="outlined"
                            color="primary"
                            className="login-page__back"
                            onClick={() => {
                                this.setState({panel: 'login'});
                                GeneralUtils.returnMainPage();
                            }}>
                            Back to login
                        </Button>
                    </div>
                </main>
            </div>
        );
    }

    getPasswordResetContent = () => {
        if (this.state.panel === 'passwordResetInit') {
            return <PasswordResetInitMerchant/>;
        } else if (this.state.panel === 'passwordResetFinish') {
            return <PasswordResetFinishMerchant activationKey={this.state.activationKey}
                                                passwordChangeKey={this.state.passwordChangeKey}/>;
        }
    }

    getLoginPanel = () => {
        const submitDisabled = this.isLoginSubmitDisabled();

        return (
            <div className="login-page login-background">
                <main className="login-page__main">
                    <CssBaseline/>
                    <div className="login-page__card">
                        {this.renderBrand()}
                        <form className="login-page__form" onSubmit={(e) => e.preventDefault()}>
                            <FormControl margin="normal" required fullWidth variant="outlined" className="login-page__field">
                                <InputLabel htmlFor="domainName">Store Name</InputLabel>
                                <OutlinedInput
                                    id="domainName"
                                    name="domainName"
                                    autoComplete="domainName"
                                    value={this.state.domainName || ''}
                                    onChange={this.__handleChange}
                                    autoFocus/>
                            </FormControl>

                            <FormControl margin="normal" required fullWidth variant="outlined" className="login-page__field">
                                <InputLabel htmlFor="userName">User Name</InputLabel>
                                <OutlinedInput
                                    id="userName"
                                    name="userName"
                                    autoComplete="username"
                                    value={this.state.userName || ''}
                                    onChange={this.__handleChange}/>
                            </FormControl>
                            <FormControl margin="normal" required fullWidth variant="outlined" className="login-page__field">
                                <InputLabel htmlFor="password">Password</InputLabel>
                                <OutlinedInput
                                    name="password"
                                    type="password"
                                    id="password"
                                    autoComplete="current-password"
                                    value={this.state.password || ''}
                                    onChange={this.__handleChange}/>
                            </FormControl>

                            <button
                                type="button"
                                className="login-page__forgot"
                                disabled={submitDisabled}
                                onClick={() => this.setState({panel: 'passwordResetInit'})}>
                                Forgot Password
                            </button>

                            {this.state.showCaptcha && (
                                <div className="login-page__captcha">
                                    <ReCAPTCHA
                                        ref={(el) => {
                                            this.reCAPTCHA = el;
                                        }}
                                        hl="en"
                                        size="normal"
                                        sitekey="6LdsjTUfAAAAAH7TpbjBwaRYmvtPEV5YqJZeXdWK"
                                        onChange={this.onChange}/>
                                </div>
                            )}

                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                disabled={submitDisabled}
                                className="login-page__submit"
                                onClick={() => this.login()}>
                                Login
                            </Button>
                        </form>
                    </div>
                </main>
            </div>
        );
    }


    __handleChange = (e) => {
        let state = {};
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        state[e.target.name] = value;
        this.setState(state);
    }

    login = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.userName) || GeneralUtils.isNullOrEmpty(this.state.password) || GeneralUtils.isNullOrEmpty(this.state.domainName)) {
            return toast.warn("User name,Password and Store Name cannot be empty!")
        }

        window.location.hash = "/";
        localStorage.setItem("userType", "merchant");
        fetch(SERVER_URL + 'security/auth/login', {
            crossDomain: true,
            method: 'post',
            headers: {'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json'},
            body: JSON.stringify({
                "domainName": this.state.domainName,
                "userName": this.state.userName,
                "password": this.state.password.toString(),
                "reCaptchaToken": this.state.reCaptchaToken
            })
        })
            .then(response => {
                if (response.ok) {
                    response.json().then((response) => {

                        if (!GeneralUtils.isNullOrEmpty(response["authCode"])) {
                            fetch(SERVER_URL + 'security/auth/token/code/' + response["authCode"], {
                                crossDomain: true,
                                method: 'post',
                                headers: {'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json'}
                            })
                                .then(response => {
                                    if (response.ok) {
                                        response.json().then((response) => {


                                            GeneralUtils.setJwtToCookie(response.accessToken, response.refreshToken, response.expireDate)
                                                .then(() => {
                                            localStorage.setItem("clientId", this.state.domainName);


                                            this.merchantBranchService.getBranchIdByDomainName(this.state.domainName).then(responseBranch => {
                                                    if (responseBranch > 0) {
                                                        if (!GeneralUtils.isNullOrEmpty(responseBranch)) {
                                                            this.licenseService.getLicenses(responseBranch).then(response => {
                                                                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type) && response.menuLicense) {
                                                                    localStorage.setItem("merchantBranchId", responseBranch);

                                                                    this.currentUserService.getCurrentMerchantUser().then(responseMerchantUser => {
                                                                        if (!GeneralUtils.isNullOrEmpty(responseMerchantUser) && GeneralUtils.isNullOrEmpty(responseMerchantUser.type)) {
                                                                            localStorage.setItem("hsmUser", JSON.stringify(responseMerchantUser));

                                                                            let merchantAccountId = JSON.stringify(responseMerchantUser.merchantAccountId);

                                                                            localStorage.setItem("domainName", responseMerchantUser.domainName);
                                                                            localStorage.setItem("merchantAccountId", merchantAccountId);
                                                                            localStorage.setItem("isAuthenticated", true);
                                                                            this.props.loginSuccess(responseMerchantUser.landingPage);
                                                                        }
                                                                    })
                                                                } else {
                                                                    return toast.warn("Your license has been expired. Payment required. Call your Service Provider.");
                                                                }

                                                            });

                                                        }
                                                    } else {
                                                        return toast.warn("The store name entered is invalid.");

                                                    }


                                                }
                                            );


                                                });
                                        });

                                    } else {
                                        this.setState({userName: '', password: '', domainName: ''});
                                        GeneralUtils.notification(response);

                                    }
                                }).catch(error => {
                                GeneralUtils.notification(error);
                            });
                        }

                    });

                } else {
                    this.setState({userName: '', password: '', domainName: ''});
                    GeneralUtils.notification(response);

                }
            }).catch(error => {
            GeneralUtils.notification(error);
        });

    }

}


LoginMerchant.propTypes = {
    loginSuccess: PropTypes.func,
};

export default LoginMerchant;
